<script setup lang="ts">
import {computed, onMounted, ref, watch } from "vue"
import VPage from '../components/VPage.vue'
import { createOneColor, getUrlParams } from '../utils'
import { useCategories, useTags } from '../composables/usePageData'
import type { CategoryTag } from '../types/post'
import { useRouter, withBase } from 'vitepress'

const props = defineProps<{ type: string }>()
const tagList = ref<string[]>([])
const tagObj = ref<CategoryTag>({})
const currentTag = ref<string>('')
const categories = useCategories()
const tags = useTags()
const posts = computed(() => {
  return tagObj.value[currentTag.value] || []
})
watch(props, (newVal) => {
  if (newVal && newVal.type === 'category') {
    if (categories) {
      tagList.value = Object.keys(categories)
      tagObj.value = categories
    }
  } else if (newVal && newVal.type === 'tag') {
    if (tags) {
      tagList.value = Object.keys(tags)
      tagObj.value = tags
    }
  }

}, {
  immediate: true
})
const router = useRouter()
let host = 'http://localhost'
router.onBeforePageLoad = (to) => {
  currentTag.value = getUrlParams(host + withBase(to), 'key') || tagList.value[0]
}
onMounted(() => {
  const location = window.location
  host = location.origin
  currentTag.value = getUrlParams(location.href, 'key') || tagList.value[0]
})
</script>

<template>
  <section class="block mx-auto mt-4 mb-16 px-4 max-w-screen-lg text-base category-tag">
    <ul class="list-none pl-0 v-tag">
      <li
        class="inline-block mr-2 mb-2 rounded-md cursor-pointer border border-solid v-tag__item"
        :class="{ 'bg-primary text-white': currentTag === value }"
        v-for="(value, index) in tagList"
        :key="index"
        :style="{ borderColor: createOneColor() }"
        @click="currentTag = value"
      >
        <a
          class="flex justify-between px-2 py-1 leading-none text-xs v-tag__link"
          :href="`/${props.type}.html?key=${value}&page=1`"
        >{{ value }}</a>
      </li>
    </ul>
    <VPage :posts="posts" :type="props.type" :current-type-val="currentTag" />
  </section>
</template>